// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3-99n","rootSmall":"AddTileButton_rootSmall__3lW55"};